import React from "react";
import PropTypes from "prop-types";
import AppContext from "../contexts/AppContext";
import Modal from "./Modal";
import i18n from "../i18n";
import * as webviewUtils from "../utils/webview";

export default class DownloadModal extends Modal {

  constructor(props) {
    super(props);
    this.className = ""; // todo
  }

  handleShareToFacebook = (e) => {
    this.props.onShare("facebook");

    webviewUtils.webviewShareFacebook(null, this.props.fileUrl);
  };

  handleShareToInstagram = (e) => {
    this.props.onShare("instagram");

    webviewUtils.webviewShare({
      providers: "[1]",
      imageUrl: encodeURIComponent(this.props.fileUrl),
      ig_direct: 1,
      close_after_share: 1,
      no_sound: 1,
    });
  };

  handleShareToSnapchat = (e) => {
    const sw = Math.floor(window.screen.width * (window.devicePixelRatio || 1));
    const stickerSize = window.clientConfig.isWebviewIOS
      ? 320
      : Math.floor(sw * 0.95);

    const shareUrl = new URL(window.appConfig.paths.app);
    const stickerUrl = new URL(this.props.fileUrl);

    webviewUtils.webviewShare({
      providers: "[11]",
      caption_text: "",
      attachment_url: encodeURIComponent(shareUrl.toString()),
      sticker_url: encodeURIComponent(stickerUrl.toString()),
      sc_sticker_posx: 0.5,
      sc_sticker_posy: 0.5,
      sc_sticker_rotation: 0.3,
      sc_sticker_width: stickerSize,
      sc_sticker_height: stickerSize,
    });
  };

  renderModal() {
    const buildVersionCode = parseInt(window.clientConfig.webviewParams.version_code);
    const isWebviewIOS = window.clientConfig.isWebviewIOS;
    const isWebviewAndroid = window.clientConfig.isWebviewAndroid;
    const snapchatIsAllow = (isWebviewIOS || (isWebviewAndroid && buildVersionCode >= 103))
        && this.context.installedApps.snapchat;

    return <div className="modal-container">
      <div className="modal">
        <h3 dangerouslySetInnerHTML={{__html: i18n.t("modal_title")}} />
        <p dangerouslySetInnerHTML={{__html: i18n.t("modal_message")}} />

        <div className="btns-container">
          <button
            className="btn-share btn-share-fb"
            hidden={window.clientConfig.isWeb || !this.context.installedApps.facebook}
            onClick={this.handleShareToFacebook}>
            <svg viewBox="0 0 38 72">
              <g fill="none" fillRule="evenodd">
                <g fill="#FFF" fillRule="nonzero">
                  <g>
                    <path d="M24.27 71.603v-32.66h10.957l1.644-12.73H24.27v-8.128c0-3.685 1.019-6.196 6.309-6.196l6.736-.003V.498C36.15.348 32.15 0 27.497 0c-9.719 0-16.372 5.932-16.372 16.824v9.388H.134v12.732h10.99v32.659H24.27z" transform="translate(-244 -1413) translate(244 1413)" />
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <button
            className="btn-share btn-share-insta"
            hidden={window.clientConfig.isWeb || !this.context.installedApps.instagram}
            onClick={this.handleShareToInstagram}>
            <svg viewBox="0 0 72 72">
              <g fill="none" fillRule="evenodd">
                <g fill="#FFF" fillRule="nonzero">
                  <g>
                    <path d="M36 .034C21.256.034 7.254-1.259 1.906 12.28-.305 17.87.016 25.132.016 35.53c0 9.124-.296 17.7 1.889 23.247C7.24 72.323 21.357 71.026 35.993 71.026c14.12 0 28.679 1.45 34.092-12.249 2.213-5.647 1.888-12.801 1.888-23.247 0-13.867.776-22.819-6.042-29.54C59.027-.819 49.69.034 35.985.034H36zm-3.224 6.397C63.535 6.383 67.45 3.01 65.29 49.86c-.768 16.57-13.56 14.752-29.284 14.752-28.67 0-29.495-.809-29.495-29.1 0-28.618 2.274-29.066 26.266-29.09v.008zm22.433 5.892c-2.383 0-4.316 1.906-4.316 4.257 0 2.352 1.933 4.258 4.316 4.258 2.384 0 4.317-1.906 4.317-4.258 0-2.35-1.933-4.257-4.317-4.257zM36.001 17.3c-10.205 0-18.478 8.163-18.478 18.229 0 10.065 8.273 18.224 18.478 18.224 10.205 0 18.473-8.159 18.473-18.224 0-10.066-8.268-18.229-18.473-18.229zm0 6.397c15.858 0 15.878 23.664 0 23.664-15.854 0-15.879-23.664 0-23.664z" transform="translate(-413 -1412) translate(413 1412)" />
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <button
            className="btn-share btn-share-snap"
            hidden={!snapchatIsAllow}
            onClick={this.handleShareToSnapchat}>
            <svg viewBox="0 0 77 72">
              <g fill="none" fillRule="evenodd">
                <g fill="#FFF" fillRule="nonzero">
                  <g>
                    <path d="M75.134 53.8c-10.245-1.685-14.863-12.18-15.05-12.626-.014-.028-.024-.057-.043-.086-.522-1.063-.647-1.94-.36-2.606.561-1.312 2.707-1.992 4.125-2.442.412-.13.8-.254 1.12-.379 1.4-.55 2.396-1.15 3.057-1.825.786-.81.939-1.585.93-2.088-.025-1.227-.964-2.319-2.463-2.85-.503-.206-1.082-.317-1.667-.317-.397 0-.991.053-1.552.317-1.197.56-2.27.867-3.195.91-.488-.024-.833-.13-1.058-.23.028-.48.057-.973.09-1.48l.015-.22c.33-5.188.738-11.64-.977-15.472-1.174-2.625-2.75-4.881-4.69-6.711-1.623-1.533-3.51-2.778-5.609-3.698-3.645-1.61-7.046-1.85-8.751-1.85h-.192l-1.317.015c-1.7 0-5.106.24-8.76 1.85-2.094.919-3.972 2.16-5.59 3.692-1.931 1.83-3.502 4.081-4.671 6.697-1.715 3.827-1.308 10.28-.982 15.462v.01c.034.555.072 1.135.105 1.7-.249.11-.656.235-1.255.235-.967 0-2.117-.307-3.415-.915-.383-.177-.819-.268-1.298-.268-.771 0-1.59.225-2.294.641-.891.523-1.466 1.255-1.624 2.075-.1.536-.096 1.604 1.092 2.687.656.594 1.614 1.145 2.855 1.633.326.13.714.25 1.12.379 1.419.45 3.57 1.13 4.13 2.442.282.666.158 1.543-.364 2.606-.015.029-.03.058-.039.086-.134.307-1.355 3.061-3.86 5.969-1.423 1.652-2.99 3.037-4.656 4.11-2.036 1.312-4.235 2.165-6.539 2.543-.905.149-1.552.953-1.499 1.868.014.264.077.527.187.781v.005c.369.857 1.216 1.58 2.596 2.218 1.686.78 4.206 1.437 7.496 1.95.168.315.34 1.106.46 1.647.125.575.254 1.169.44 1.796.202.68.72 1.495 2.056 1.495.508 0 1.087-.115 1.763-.245.986-.191 2.337-.455 4.018-.455.934 0 1.902.082 2.874.245 1.878.31 3.497 1.451 5.37 2.773 2.74 1.935 5.844 4.124 10.586 4.124.13 0 .259-.005.388-.014.153.01.35.014.55.014 4.743 0 7.847-2.189 10.587-4.12l.005-.004c1.872-1.317 3.491-2.457 5.37-2.769.972-.162 1.94-.244 2.873-.244 1.61 0 2.884.206 4.019.426.742.144 1.317.216 1.763.216h.086c.977 0 1.696-.537 1.969-1.47.182-.619.311-1.193.44-1.782.11-.508.293-1.323.455-1.639 3.291-.517 5.81-1.168 7.497-1.95 1.374-.636 2.222-1.36 2.591-2.212.11-.254.177-.518.192-.79.052-.906-.594-1.715-1.5-1.86z" transform="translate(-596 -1413) translate(596 1413)" />
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <button className="btn-close" children={i18n.t("modal_button")} onClick={() => this.dismiss()} />
        </div>
      </div>
    </div>
  }
}

DownloadModal.contextType = AppContext;

DownloadModal.propTypes = {
  fileUrl: PropTypes.string.isRequired,
  onShare: PropTypes.func.isRequired,
};